import { FC } from 'react';
import { ITalentPets } from 'shared/interfaces/IPets';
import { PETS_QUESTION } from 'shared/constants/PETS_QUESTIONS';
import { PawIcon } from '@room-match/shared-ui-components';
import InfoViewModal from 'components/MyInfo/InfoViewModal/InfoViewModal';
import { getAnimalAgeDetails } from 'shared/utils/getAnimalAgeDetails';

type PetViewModalProps = {
  data: ITalentPets;
  openDialog: boolean;
  handleDialog: VoidFunction;
};

const PetViewModal: FC<PetViewModalProps> = ({ data, openDialog, handleDialog }) => {
  const animalType = data?.animal?.toLowerCase();
  const infoViewOtherDetails =
    (animalType === 'dog' || animalType === 'cat') && PETS_QUESTION[animalType]
      ? PETS_QUESTION[animalType].map((question: string) => ({
          name: question,
          details: data?.others?.includes(question) ? 'Yes' : 'No',
        }))
      : [];
  const ageDetails = getAnimalAgeDetails({
    age_in_months: data?.age_in_months,
    age: data?.age,
    time_period_type: 'full',
  });
  const infoViewDetailsData = [
    { name: 'Animal', details: data?.animal },
    { name: 'Breed', details: data?.breed },
    { name: 'Size', details: data?.size },
    { name: 'Age', details: ageDetails },
    ...infoViewOtherDetails,
  ];
  const infoViewImageData = data?.attached_media;
  return (
    <InfoViewModal
      headerIcon={<PawIcon fontSize="inherit" />}
      openDialog={openDialog}
      handleDialog={handleDialog}
      infoViewDetailsData={infoViewDetailsData}
      infoViewImageData={infoViewImageData}
      title="Pet"
    />
  );
};

export default PetViewModal;
